import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { useAppSelector } from "../../../hooks/hooks";
import LoadingPage from "../../presentationalComponents/LoadingPage";
import Container from "../../../components/Container";
import { TourOverview } from "../../../services/restserver-openapi";
import TourCard from "../TourCard";

interface SuggestedToursProps {
    generatedTours: TourOverview[] | undefined;
    onTourSelected?: (tourId: number) => void;
}

function SuggestedTours({ generatedTours, onTourSelected }: SuggestedToursProps) {
    const isLoading = useAppSelector((state) => state.tour.loading);

    const iterateThroughStays = (stays: any): string[] => {
        const waypoints: string[] = [];
        stays?.forEach((stay: any) => {
            if (stay?.coordinates?.x != null && stay?.coordinates?.y != null) {
                waypoints.push(`${stay.coordinates.x},${stay.coordinates.y}`);
            }
        });
        return waypoints;
    };

    return (
        <Container>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <Box>
                    <Box marginBottom={4}>
                        <Typography sx={{ textTransform: "uppercase", fontWeight: "medium" }} gutterBottom color={"text.secondary"}>
                            Individuell für dich
                        </Typography>
                        <Typography variant={"h4"} sx={{ fontWeight: 700 }} align={"left"}>
                            Hier sind Deine persönlichen Reisevorschläge
                        </Typography>
                        <Typography variant="h6" component="p" color="text.secondary" align={"left"}>
                            Klick auf eine Tour damit Du die Details sehen und bearbeiten kannst.
                        </Typography>
                    </Box>

                    <Grid container spacing={4}>
                        {generatedTours?.map((tour, index) => (
                            <Grid item xs={12} sm={6} md={4} key={tour.tourId ?? index}>
                                {tour.tourId && tour.stays && tour.stays.length >= 1 && (
                                    <TourCard
                                        tour={tour}
                                        waypoints={iterateThroughStays(tour.stays)}
                                        index={index}
                                        onTourSelected={onTourSelected}
                                    />
                                )}
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
        </Container>
    );
}

export default SuggestedTours;
